import React from 'react'

import {
  WebtraderMediaStyled,
  WebtraderMediaContentStyled,
  WebtraderMediaBgStyled,
  WebtraderMediaBoxStyled,
  WebtraderMediaIconsListStyled,
  WebtraderMediaIconsListItemStyled
} from './styles'
import { WebtraderMediaProps } from './types'
import MediaItem from '../../molecules/MediaItem'
import Badge from '../../atoms/Badge'

const WebtraderMedia: React.FC<WebtraderMediaProps> = ({ media, iconsList }) => (
  <WebtraderMediaStyled>
    <WebtraderMediaContentStyled>
      {media && (
        <WebtraderMediaBoxStyled>
          <WebtraderMediaBgStyled>
            <MediaItem {...{ media }} />
          </WebtraderMediaBgStyled>
        </WebtraderMediaBoxStyled>
      )}
      {iconsList && (
        <WebtraderMediaIconsListStyled>
          {iconsList.map((item) => (
            <WebtraderMediaIconsListItemStyled key={item.key}>
              <Badge image={item.icon} />
            </WebtraderMediaIconsListItemStyled>
          ))}
        </WebtraderMediaIconsListStyled>
      )}
    </WebtraderMediaContentStyled>
  </WebtraderMediaStyled>
)

export default WebtraderMedia
